import React from 'react';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import createHistory from 'history/createBrowserHistory';
import {Card, CardText, CardActions} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import TextField from 'material-ui/TextField';

class Stocktaking extends React.Component {
  constructor(props) {
    super(props);
    const {standKey} = this.props.match.params;
    this.initialState =  {
      standKey,
      standname:'',
      loadingIndicator: 'flex',
      products: [],
    };

    this.state = {
      ...this.initialState
    };

  }
  componentDidMount = () => {
    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;

    if (!this.standNameRef) {
      this.standNameRef = firebase.database().ref(`shopkeepers/${shopkeeperId}/stands/${this.state.standKey}/name`);
      this.standNameRef.once('value').then((data) => {
        this.setState({standname : data.val()});
      });
    }
    if (!this.standProductsRef) {
      this.standProductsRef = firebase.database().ref(`shopkeepers/${shopkeeperId}/stands/${this.state.standKey}/products`).orderByChild('name');
      this.standProductsRef.once('value', (products) => {
        products.forEach((data) => {
          let product = {
            key: data.key,
            ...data.val()
          };

          const currentProducts = this.state.products.slice();
          product.pictureUrl = '';
          currentProducts.push(product);
          this.setState({products: currentProducts});
        });
      }).then(this.setState({loadingIndicator: 'none'}));
    }
  }
  handleActualCount = (event, product) => {
    const isInteger = event.target.value >>> 0 === parseFloat(event.target.value);
    const isEmpty = event.target.value === '';

    if (isInteger || isEmpty) {
      product.actualCount = event.target.value;
      product.changeCount = +(product.actualCount || product.totalCount || 0) - +(product.totalCount || 0);
      const currentProducts = this.state.products.slice();
      const index = currentProducts.findIndex((item) => (item.key === product.key));
      currentProducts[index] = product;
      this.setState({products: currentProducts});
    } else {
      product.changeCount = 0;
      const currentProducts = this.state.products.slice();
      const index = currentProducts.findIndex((item) => (item.key === product.key));
      currentProducts[index] = product;
      this.setState({products: currentProducts});
    }
  }
  handleSave = () => {
    const {firebase, user} = this.props;
    const today = new Date().getTime();
    this.state.products.forEach((product) => {
      const changeCount = product.changeCount || 0;
      firebase.database().ref(`shopkeepers/${user.shopkeeperId}/inventoryChanges`)
        .push({date: today, delta: changeCount, inventoryCheck: true, standId: this.state.standKey, productId: product.key});
      if (changeCount !== 0) {
        firebase.database().ref(`shopkeepers/${user.shopkeeperId}/stands/${this.state.standKey}/products/${product.key}`)
          .update({totalCount: product.actualCount});
      }
    });
    createHistory().goBack();
  }
  render() {
    const {t} = this.props;

    const products =
    this.state.products.map((product) => (
      <TableRow key={product.key}>
        <TableRowColumn style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>
          {product.name}
        </TableRowColumn>
        <TableRowColumn style={{textAlign: 'right'}}>
          {product.totalCount || 0}
        </TableRowColumn>
        <TableRowColumn style={{textAlign: 'right', width: 30}}>
          <TextField
            id={product.key + 'should'}
            type='number'
            min='0'
            max='99999'
            style={{width: 30, fontSize: '13px'}}
            inputStyle={{textAlign: 'right'}}
            onChange={(event) => this.handleActualCount(event, product)}
          />
        </TableRowColumn>
        <TableRowColumn style={(product.changeCount<0) ? {textAlign: 'right', color: '#f44336'} : {textAlign: 'right'}}>
          {product.changeCount || 0}
        </TableRowColumn>
      </TableRow>
    ));
    return (
      <Card className='cardStyle' >
        <Toolbar>
          <ToolbarGroup firstChild={true}>
            <IconButton onTouchTap={createHistory().goBack}>
              <ArrowBack color="rgba(0,0,0,0.4)" />
            </IconButton>
            <ToolbarTitle text={t('inventory.stocktakingFor') + ' ' + this.state.standname} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <Table style={{tableLayout: 'auto'}} bodyStyle={{overflow:'visible'}}
            selectable={false}>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn style={{color: '#9e9e9e'}}>{t('product.product')}</TableRowColumn>
                <TableRowColumn style={{textAlign: 'right', color: '#9e9e9e'}}>{t('inventory.shouldHave')}</TableRowColumn>
                <TableRowColumn style={{textAlign: 'right', color: '#9e9e9e'}}>{t('inventory.actualCount')}</TableRowColumn>
                <TableRowColumn style={{textAlign: 'right', color: '#9e9e9e'}}>{t('inventory.changeCount')}</TableRowColumn>
              </TableRow>
              {products}
            </TableBody>
          </Table>
          <LoadingIndicator display={this.state.loadingIndicator} />
        </CardText>
        <CardActions>
          <RaisedButton label={t('save')} primary  onTouchTap={this.handleSave} />
        </CardActions>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(Stocktaking);



// WEBPACK FOOTER //
// ./src/Stand/Stocktaking.js